import { createTheme, responsiveFontSizes, type PaletteMode } from "@mui/material/styles";
import projectColors from "./projectColors";

export const createAppTheme = (mode: PaletteMode) => {
  let theme = createTheme({
    palette: {
      mode,
      primary: {
        ...projectColors.primary,
        // En dark mode, ajustar el color primary para mejor visibilidad
        main: mode === "dark" ? "#4A90E2" : projectColors.primary.main,
        light: mode === "dark" ? "#6BA3E8" : projectColors.primary.light,
      },
      secondary: projectColors.secondary,
    },
  });

  theme = createTheme({
    palette: theme.palette,
    components: {
      MuiTypography: {
        defaultProps: {
          // No establecer color para que use el default del tema automáticamente
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
            "& .Mui-disabled": {
              color: mode === "dark" ? "#ccc" : "black",
            },
            "& .MuiOutlinedInput-input.Mui-disabled": {
              "-webkit-text-fill-color": "unset",
            },
          },
        },
      },
      MuiButton: {
        defaultProps: {
          variant: "contained",
        },
        styleOverrides: {
          text: {
            color: "#fff",
          },
          root: {
            marginTop: theme.spacing(0),
            marginBottom: theme.spacing(0),
            textTransform: "initial",
            borderRadius: 10,
          },
        },
      },
      MuiContainer: {
        defaultProps: {
          maxWidth: "lg",
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            backgroundColor: theme.palette.primary.main,
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            color: theme.palette.primary.contrastText,
            fontWeight: "bold",
          },
        },
      },
      MuiCardHeader: {
        styleOverrides: {
          root: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            textAlign: "center",
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            maxWidth: "95vw",
          },
        },
      },
    },
  });

  theme = responsiveFontSizes(theme);

  return theme;
};
